module.exports = __webpack_public_path__ + "img/730.18c7a09f.png";